export const DS_FUNCTION = {
	DEEP_LINK_ORIGIN: "DEEP_LINK_ORIGIN",
};

export const DS_SUBFUNCTION = {
	NEW_REGISTER: "NEW_REGISTER",
	NEW_LOGIN: "NEW_LOGIN",
};
